export default __webpack_public_path__ + "static/media/PolisportSVGMini.fe54545b.svg";